import React from 'react';
import { QuestionOutlined } from '@ant-design/icons';

import Docs from '../../containers/docs/Docs';

const DocsLink = ({ scrolTo, styleIcon, linkClassName, text }) => (
  <Docs scrolTo={scrolTo}>
    <a className={linkClassName}>
      <QuestionOutlined style={styleIcon} />
      {text}
    </a>
  </Docs>
);

export default DocsLink;
